import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BsPersonCircle, BsKey } from "react-icons/bs";
import Input from "../../../components/Input";
import Button from "../../Button";
export default function ChangePasswordScreen({ open, onClose, onChangePassword }) {
const [newPassword, setNewPassword] = React.useState('');
const [confirmPassword, setConfirmPassword] = React.useState('');
const [oldPassword, setOldPassword] = React.useState('');

  const isFormValid =
    oldPassword.trim() !== "" &&
    newPassword.trim() !== "" &&
    confirmPassword.trim() !== "" &&
    newPassword === confirmPassword;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white rounded-lg shadow-xl w-[90%] max-w-md p-6"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            <div className="flex items-center gap-3 mb-4">
            
              <div>
                <h3 className="text-lg font-semibold text-gray-800">Zmiana hasła dostępu</h3>
                <p className="text-sm text-gray-500">Zmień hasło w celach bezpieczeństwa</p>
                <p className="text-xs text-gray-400">Po zmianie stare hasło nie będzie juz działało. Zaleca się trymać hasła dostępu w bzpiecznym miejscu</p>
              </div>
            </div>

            <div className="space-y-3 mb-6">
                <div >
                 
                  <Input 
                  label="Podaj stare hasło" 
                  id="oldPassword" 
                  placeholder="Stare hasło" 
                  fullWidth
                  value={oldPassword}
                  onChange={(e) => setOldPassword(e.target.value)}
                  type="password" />
                </div>
                                <p className="text-xs text-gray-400">Podaj nowe hasło. Oba pola powinny być zgodne</p>

                <div>
                  <Input 
                  label="Podaj nowe hasło" 
                  id="newPassword" 
                  placeholder="Nowe hasło" 
                  fullWidth
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  type="password" />
                </div>
                <div>
                  <Input 
                  label="Powtórz nowe hasło" 
                  id="confirmPassword" 
                  placeholder="Powtórz nowe hasło" 
                  fullWidth
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  type="password" />
                </div>
                
             
            </div>

            <div className="flex justify-end">
                 <Button
                  size="small"
          
          color="warning"
                className="flex items-center gap-2 mr-2"
                onClick={()=>onChangePassword({oldPassword,newPassword,confirmPassword})}
                disabled={!isFormValid}
              >
                <BsKey /> Aktualizuj hasło
              
              </Button>
           
              <Button     size="small"
          variant="outlined"
          color="success"
                onClick={onClose}
               
              >
                Zamknij
              </Button>
            </div>
          </motion.div>
        </motion.div>
      )}


    </AnimatePresence>
  );
}
